import RequestCache from "./RequestCache";

export default class AnketaAnswers extends RequestCache {
    get link() {
        return this.links.anketaAnswers;
    }

    get cacheInterval() {
        return 7;
    }
}
